import React from 'react';
import './UserDisplay.scss';
import { Avatar } from '../avatar/Avatar';
import { Icon } from '../icon/Icon';
import { DossierMember } from '../../models/DossierMember';
import { SingleUser } from '../../api/types';
import { User } from '../../models/User';

interface UserDisplayProps {
  user?: DossierMember|User|SingleUser;
  icon?: string;
  title?: string;
  subTitle?: string;
  small?: boolean;
  className?: string;
}

function getUser(member: DossierMember|User|SingleUser): User|SingleUser {
  return member instanceof DossierMember ? member.user : member;
}

export function UserDisplay(props: UserDisplayProps): JSX.Element {
  const { user, icon, title, subTitle, small, className } = props;
  return <div className={`user-display ${className || ''} ${small ? 'user-display--small' : ''}`}>
    {
      !!(user || icon) &&
        <>
          { user && <Avatar className="user-display__avatar" user={getUser(user)} /> }
          { icon && <Icon className="user-display__avatar user-display__avatar--icon" icon={icon} /> }
        </>
    }
    <div>
      <div className="user-display__title">{title || (user ? getUser(user).name : '') }</div>
      <div className="user-display__sub-title">{subTitle || ''}</div>
    </div>
  </div>;
}
